import { fetchBase, FetchSuccess } from "./managers";

const getFeatureFlags = async () => {
  try {
    const res = await fetchBase(`user-dashboard/feature-flags`, null, {});
    return new FetchSuccess(res);
  } catch (res) {
    throw res;
  }
};

export default getFeatureFlags;
